import React from 'react';
import { withStyles, lighten } from '@material-ui/core/styles';
import { colors } from 'globalStyle';
import LinearProgress from '@material-ui/core/LinearProgress';

export const Progress = ({
  percent = 0,
  height = 8,
  marginBottom = 8,
  borderRadius = 50,
  onProgressColor = colors.secondary,
  onCompletedColor = colors.success,
}) => (
  <StyledProgress
    backgroundColor={percent >= 100 ? onCompletedColor : onProgressColor}
    height={height}
    marginBottom={marginBottom}
    borderRadius={borderRadius}
    variant="determinate"
    value={percent >= 100 ? 100 : percent}
  />
);

export const StyledProgress = withStyles({
  root: {
    height: (props) => props.height && props.height,
    borderRadius: (props) => props.borderRadius && props.borderRadius,
    backgroundColor: lighten(colors.GRAY_1, 0.5),
    marginBottom: (props) => props.marginBottom && props.marginBottom,
  },
  bar: {
    borderRadius: (props) => props.borderRadius && props.borderRadius,
    backgroundColor: (props) => props.backgroundColor && props.backgroundColor,
  },
})(LinearProgress);
